module.exports = __webpack_public_path__ + "img/GoLog.42c61a18.png";